import React from 'react'
import RequestVirtualCard from 'src/app/RequestVirtualCard/RequestVirtualCard'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { requestVirtualCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const RequestVirtualCardAppRoute: AppRoute = {
  id: AppLocation.RequestVirtualCard,
  routeProps: requestVirtualCardRouteProps,
  component: <RequestVirtualCard />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default RequestVirtualCardAppRoute
